import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InviteComponent } from './invite.component';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';



@NgModule({
  declarations: [
    InviteComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    RouterModule,
  ],
  exports: [
    InviteComponent
  ]
})
export class InviteModule { }
